/**
 * Per-brand font registry.
 *
 * A brand opts into a custom typeface via `branding.fontFamily` (DB) or its
 * code brand file. The value must match a key here for the webfont to load —
 * an explicit allow-list of self-hosted faces (via `@fontsource-*`) so an
 * arbitrary DB string can never trigger an unbounded or external font fetch.
 * A brand with no (or an unknown) `fontFamily` keeps the default `--font-sans`.
 */
export interface FontRegistryEntry {
  /** Lazily loads the self-hosted webfont CSS. Best-effort (fire-and-forget). */
  load: () => Promise<unknown>;
  /** CSS font-family stack applied to `--font-sans` once selected. */
  stack: string;
}

export const FONT_REGISTRY: Record<string, FontRegistryEntry> = {
  'DM Sans': {
    load: () => import('@fontsource-variable/dm-sans'),
    stack: "'DM Sans Variable', 'DM Sans', system-ui, -apple-system, sans-serif",
  },
};
